import { Box, Grid, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import Navbar from "../components/Navbar";
import EmployerSidebar from "../components/Employer/EmployerSidebar";
import SearchIcon from '@mui/icons-material/Search';
import Layout from "../assets/Layout";
import UserLayout from "../assets/UserLayout";
import AllApplicationsTable from "../components/Employer/AllApplicationsTable";

const AllApplications = () => {
    const [search, setSearch] = useState("");
    return (
        <>
            <Layout>
                <UserLayout userRole={"employer"}>
                    <Grid container mt={8}>
                        <Grid item md={8}>
                            <Typography className="heading1bold">
                                Applications
                            </Typography>
                        </Grid>
                        <Grid item md={4}>
                            <TextField
                                sx={{
                                    background: '#F8FAFF',
                                    boxShadow: '0px 23.48060417175293px 46.96120834350586px -8.80522632598877px #3665D014',
                                }}
                                variant="outlined"
                                size="small"
                                placeholder="Search"
                                InputProps={{
                                    endAdornment: <SearchIcon sx={{ opacity: '0.5' }} />,
                                }}
                                onChange={(e) => setSearch(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                    <Box mt={2}>
                    <AllApplicationsTable/>
                    </Box>
                </UserLayout>
            </Layout>
        </>
    )
}
export default AllApplications;